const map = {
	"./bear.svg": 37460,
	"./bee.svg": 24630,
	"./bird.svg": 40851,
	"./bird2.svg": 52523,
	"./bird3.svg": 47258,
	"./crab.svg": 69840,
	"./deer.svg": 21822,
	"./elephant.svg": 7901,
	"./fox.svg": 91165,
	"./lion.svg": 84336,
	"./monkey.svg": 16665,
	"./octopus.svg": 81569,
	"./owl.svg": 73400,
	"./panda.svg": 60306,
	"./penguin.svg": 8474,
	"./seal.svg": 74625,
	"./starfish.svg": 15136,
	"images/rooms/avatars/bear.svg": 37460,
	"images/rooms/avatars/bee.svg": 24630,
	"images/rooms/avatars/bird.svg": 40851,
	"images/rooms/avatars/bird2.svg": 52523,
	"images/rooms/avatars/bird3.svg": 47258,
	"images/rooms/avatars/crab.svg": 69840,
	"images/rooms/avatars/deer.svg": 21822,
	"images/rooms/avatars/elephant.svg": 7901,
	"images/rooms/avatars/fox.svg": 91165,
	"images/rooms/avatars/lion.svg": 84336,
	"images/rooms/avatars/monkey.svg": 16665,
	"images/rooms/avatars/octopus.svg": 81569,
	"images/rooms/avatars/owl.svg": 73400,
	"images/rooms/avatars/panda.svg": 60306,
	"images/rooms/avatars/penguin.svg": 8474,
	"images/rooms/avatars/seal.svg": 74625,
	"images/rooms/avatars/starfish.svg": 15136,
	"rooms/avatars/bear.svg": 37460,
	"rooms/avatars/bee.svg": 24630,
	"rooms/avatars/bird.svg": 40851,
	"rooms/avatars/bird2.svg": 52523,
	"rooms/avatars/bird3.svg": 47258,
	"rooms/avatars/crab.svg": 69840,
	"rooms/avatars/deer.svg": 21822,
	"rooms/avatars/elephant.svg": 7901,
	"rooms/avatars/fox.svg": 91165,
	"rooms/avatars/lion.svg": 84336,
	"rooms/avatars/monkey.svg": 16665,
	"rooms/avatars/octopus.svg": 81569,
	"rooms/avatars/owl.svg": 73400,
	"rooms/avatars/panda.svg": 60306,
	"rooms/avatars/penguin.svg": 8474,
	"rooms/avatars/seal.svg": 74625,
	"rooms/avatars/starfish.svg": 15136
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13340;